export default "__VITE_ASSET__1Ld8UXKA__"